import { textToKebab} from './toKebabCase'

const topicUrlGenerator = (type: string, title: string, id: string, category?: string) => {
    const typePath = `/${type}`
    const categoryPath = category ? `/${category}` : ''
    const titlePath = `/${textToKebab(title)}`
    const idPath = `-${id}`
    return (typePath + categoryPath + titlePath + idPath).toLowerCase() as string
}

export default topicUrlGenerator